import React, { Component } from 'react';
import * as $ from 'jquery';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import Room from '../../dashboard/reservations/Room.js';
import RoomPayment from '../../dashboard/reservations/payment/PaymentContainer.js';
import RoomsContainer from '../../dashboard/reservations/RoomsContainer.js';
import Store from './Store.js';
import axios from 'axios';
import { Redirect, Route, Switch } from 'react-router-dom';
import { USER_TYPE } from '../../App.js';
import { translate } from 'react-i18next';

let cancelToken;

class StoreContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    $(window).off("resize", this.resize);
  }

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  didGetCenters = (response) => {
    this.setState({ centers: response });

    this.handleOptionUpdate();
  }

  getCenters = (params) => {
    this.props.post(
      "/getCenters",
      params,
      (response) => this.didGetCenters(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleOptionUpdate = () => {
    if ($("#center-results").children().length) {
      $("#center-results").css("display", "");
    } else {
      $("#center-results").css("display", "none");
    }
  }

  getInitState = () => {
    return {
      center: null,
      centerQuery: "",
      centers: [],
      user: {
        member: USER_TYPE.GUEST,
        no_account: true
      }
    };
  }

  getPermissionStatus = () => {
    // No aplica para usuario sin cuenta
    return null;
  }

  getTokenSession = () => {
    // No aplica para usuario sin cuenta
    return "";
  }

  handleCenterClick = (center) => {
    this.setState({
      center: center,
      centerQuery: center.name
    });
  }

  handleCenterSearch = (event) => {
    const getCenters = () => this.getCenters({
      query: this.state.centerQuery,
      token_id: this.props.getTokenId()
    });

    this.setState({
      center: null,
      centerQuery: event.target.value
    }, getCenters);
  }

  resize = () => {
    $('#content').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  renderFooter = () => {
    return (
      <Footer />
    );
  }

  renderNavbar = () => {
    return (
      <Navbar
        handleLanguageChange={this.props.handleLanguageChange}
        lang={this.props.lang} />
    );
  }

  renderPage = () => {
    return (
      <Switch>
        <Route exact path="/store_old" component={this.renderStore} />
        <Route exact path="/store_old/reservations" component={this.renderRoomsContainer} />
        <Route exact path="/store_old/reservations/:reservationid" component={this.renderRoom} />
        <Route exact path="/store_old/reservations/:reservationid/payment" component={this.renderRoomPayment} />
        <Route path="/store_old" component={() => <Redirect to="/store_old" />} />
      </Switch>
    );
  }

  renderRoom = () => {
    return (
      <div className="overlay_sala">
        <div id="content_sala" className="container_sala">
          <div className="container-fluid">
            <Room user={this.state.user} />
          </div>
        </div>
      </div>
    );
  }

  renderRoomPayment = () => {
    return (
      <div className="overlay_sala">
        <div id="content_sala" className="container_sala">
          <div className="container-fluid">
            <RoomPayment
              getTokenId={this.props.getTokenId}
              getTokenSession={this.getTokenSession}
              handleErrorResponse={this.props.handleErrorResponse}
              post={this.props.post}
              user={this.state.user} />
          </div>
        </div>
      </div>
    );
  }

  renderRoomsContainer = () => {
    return (
      <div className="overlay_sala">
        <div id="content_sala" className="container_sala">
          <div className="container-fluid">
            <RoomsContainer
              center={this.state.center}
              centerQuery={this.state.centerQuery}
              centers={this.state.centers}
              getPermissionStatus={this.getPermissionStatus}
              getTokenId={this.props.getTokenId}
              getTokenSession={this.getTokenSession}
              handleErrorResponse={this.props.handleErrorResponse}
              post={this.props.post}
              user={this.state.user} />
          </div>
        </div>
      </div>
    );
  }

  renderStore = () => {
    return (
      <div className="overlay">
        <div id="content" className="container">
          <div className="store-singup">
            <Store
              center={this.state.center}
              centerQuery={this.state.centerQuery}
              centers={this.state.centers}
              handleCenterClick={this.handleCenterClick}
              handleCenterSearch={this.handleCenterSearch}
              handleRoomSearch={this.handleRoomSearch}
              handleLanguageChange={this.props.handleLanguageChange}
              lang={this.props.lang} 
              />
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.user) {
      return <Redirect to="/reservations" />;
    }


    return (
      <div className="store-container">
        {this.renderNavbar()}
        {this.renderPage()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default translate('common')(StoreContainer);



// WEBPACK FOOTER //
// ./src/guest/store/StoreContainer.js